<template>
    <transition name="fade">
        <div class="player-in-report-modal" :id="id">
            <Loader v-if="isLoader" style="display: inline; position: inherit"></Loader>
            <div class="modal-content relative">
                <div class="close-button absolute flex justify-between justify-start">
                    <div class="leading-none">
                        <i
                            @click="closeModal"
                            class="fas fa-times-circle text-xl font-size-24 shadow-text-none cursor-pointer"
                        ></i>
                    </div>
                </div>
                <div class="modal-body text-center">
                    <x-button
                        :disabled="report.playing_type == 'live' && typeof report.pdf_path == 'undefined'"
                        style="display: inline"
                        :class="{ 'disabled-report': isDisabledPdf }"
                        class="py-2 mr-2 shadow-text-none text-black no-underline report-download"
                        @click="typeReport == 'file' ? downloadReportPdf(report) : googleDriveReportPdf(report, 'pdf')"
                        href="#"
                    >
                        <i class="fas fa-file-pdf shadow-text-none icon-download-size"></i>
                    </x-button>
                    <x-button
                        :disabled="
                            report.playing_type == 'live' &&
                            (typeof report.xlsx_path == 'undefined' || !report.xlsx_path)
                        "
                        style="display: inline"
                        :class="{ 'disabled-report': isDisabledXlsx }"
                        class="py-2 ml-2 shadow-text-none text-black no-underline report-download"
                        @click="
                            typeReport == 'file'
                                ? downloadReportXlsx(report, report.result_data.type)
                                : googleDriveReportXlsx(report, 'xlsx')
                        "
                        href="#"
                    >
                        <i class="fas fa-file-excel shadow-text-none icon-download-size"></i>
                    </x-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway'
import XButton from '@/components/v2/XButton'
import UserService from '@/lib/user'
import Request from '@/lib/request'
import Loader from '@/components/Loader'

export default {
    name: 'player-in-report-modal',

    components: {
        Loader,
        XButton
    },

    directives: {
        onClickaway: onClickaway
    },

    props: {
        report: {},

        id: {
            type: String,
            default: 'unset'
        },

        typeReport: {
            type: String,
            default: 'unset'
        }
    },

    data() {
        return {
            isLoading: false,
            isDisabledPdf: false,
            isDisabledXlsx: false,
            isLoader: false
        }
    },

    mounted() {
        if (this.typeReport == 'file') {
            if (this.report.playing_type == 'live' && typeof this.report.xlsx_path == 'undefined') {
                this.isDisabledPdf = true
            }

            if (this.report.playing_type == 'live' && typeof this.report.xlsx_path == 'undefined') {
                this.isDisabledXlsx = true
            }
        }
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        downloadReportPdf(report) {
            this.isLoader = true
            this.$emit('download-report-pdf', { report })
        },

        downloadReportXlsx(report, type = 'quiz') {
            this.isLoader = true
            this.$emit('download-report-xlsx', { report: report, type: type })
        },

        createRequest() {
            const userService = new UserService()
            const token = userService.getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        googleDriveReportPdf(report, type) {
            this.isLoader = true

            this.$emit('google-drive-report-pdf', { report: report, playingType: report.playing_type, type: type })
        },

        googleDriveReportXlsx(report, type) {
            this.isLoader = true

            this.$emit('google-drive-report-xlsx', { report: report, playingType: report.playing_type, type: type })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/mixin.scss';

.player-in-report-modal {
    font-family: 'Open Sans', sans-serif !important;
    position: absolute;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
    min-height: 200px;
    top: 0;
    left: 0;

    .close-button {
        top: 0.5rem;
        right: 0.5rem;
    }

    .modal-content {
        display: flex;
        flex-direction: column;

        margin-top: 4rem;
        padding: 1rem 1rem;
        width: 700px !important;
        overflow: hidden;
        border-radius: 3px;

        @include screen-max-lg {
            width: 100% !important;
            height: 100% !important;
            margin: 0rem 0rem;
        }

        .modal-body {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            max-height: 60vh;
            overflow-y: auto;

            .icon-download-size {
                font-size: 42px;
            }

            .report-download {
                width: 65px;
                height: 65px;
            }
        }
    }
}

.disabled-report {
    opacity: unset;
}
</style>
